import { ConnectedConsumeReport } from 'widgets/report/consume';

export function ConsumeReportPage() {
  return <ConnectedConsumeReport />;
}
